// Character-level helpers shared by import scanner and rule handlers.
// Example: top-level content checks rely on consistent whitespace rules.

// Check if one character is whitespace.
export function isWhitespace(char: string): boolean {
  // Return true when character matches a known whitespace code.
  return char === ' ' || char === '\t' || char === '\n' || char === '\r' || char === '\f'
}

// Build at-rule name string from statement text.
export function parseTopLevelAtRuleName(statement: string): string {
  let index = 1
  // Skip spaces after `@` prefix.
  while (index < statement.length && isWhitespace(statement[index])) {
    index += 1
  }

  const start = index
  // Build name by scanning chars until separator.
  while (index < statement.length && isNameChar(statement[index])) {
    index += 1
  }
  // Return lowercase at-rule name for deterministic matching.
  return statement.slice(start, index).toLowerCase()
}

// Check if one character is valid in at-rule names.
function isNameChar(char: string): boolean {
  const code = char.charCodeAt(0)
  // Allow ascii letters and digits.
  if ((code >= 65 && code <= 90) || (code >= 97 && code <= 122) || (code >= 48 && code <= 57)) {
    // Return true for alphanumeric character codes.
    return true
  } else {
    // Allow `_` and `-` separators.
    return char === '_' || char === '-'
  }
}

